module.exports = __webpack_public_path__ + "static/media/bear_1.60a9cb7a.jpg";